import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-[1280px] mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
            <div>
              <Link to="/" className="flex items-center gap-2 mb-4 group">
                <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                  <i className="ri-fire-line text-xl text-background-50"></i>
                </div>
                <span className="text-xl font-bold font-heading">热久久</span>
              </Link>
              <p className="text-sm text-foreground-300 leading-relaxed">
                专为寒冷环境打造的持久保暖品牌。先进发热技术，持久恒温性能，让温暖触手可及。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold mb-4 text-background-50">
                <a href="#footer-products" className="hover:text-primary-400 transition-colors">产品系列</a>
              </h4>
              <ul className="space-y-3">
                <li><Link to="/categories" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">保暖贴系列</Link></li>
                <li><Link to="/categories" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">户外取暖系列</Link></li>
                <li><Link to="/categories" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">日常暖身系列</Link></li>
                <li><Link to="/categories" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">冬季装备系列</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold mb-4 text-background-50">
                <a href="#footer-guide" className="hover:text-primary-400 transition-colors">暖身指南</a>
              </h4>
              <ul className="space-y-3">
                <li><Link to="/articles/a001" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">冬季户外保暖攻略</Link></li>
                <li><Link to="/articles/a002" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">保暖贴使用方法</Link></li>
                <li><Link to="/articles/a003" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">户外工作者方案</Link></li>
                <li><Link to="/articles/a004" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">保暖科技解读</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold mb-4 text-background-50">
                <a href="#footer-contact" className="hover:text-primary-400 transition-colors">联系我们</a>
              </h4>
              <ul className="space-y-3">
                <li className="flex items-start gap-2">
                  <i className="ri-phone-line text-primary-400 mt-0.5"></i>
                  <span className="text-sm text-foreground-300">400-888-9999</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-mail-line text-primary-400 mt-0.5"></i>
                  <span className="text-sm text-foreground-300">service@rejiujiu.com</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-map-pin-line text-primary-400 mt-0.5"></i>
                  <span className="text-sm text-foreground-300">中国·上海</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="pt-8 border-t border-foreground-200/20 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-300">
              &copy; {new Date().getFullYear()} 热久久 版权所有
            </p>
            <div className="flex items-center gap-6">
              <Link to="/about" className="text-xs text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">关于我们</Link>
              <a href="#privacy" className="text-xs text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">隐私政策</a>
              <a href="#terms" className="text-xs text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">服务条款</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}